import React from 'react';
import './style/btnFormat.css';

function BtnFormat(props) {
    return (
        <div className="btn_format_box">
            <button className={`btn_format ${props.style}` } >{props.title}</button>
        </div>
    );
}

export default BtnFormat;